import { Input } from "@educrib/firefly";

export default function Id() {
  return <Input type="hidden" name="id" />;
}
